import {createStore} from '../alt';

import SingleObjectResource, {InvalidResponseCode} from '../resources/GenericResource';
import CurrentUserActions from '../actions/CurrentUserActions';
import ChatMessageIsReadActions from '../actions/ChatMessageIsReadActions';


const ChatMessageIsReadSource = {
    create() {
        return {
            remote(state, count, id) {
                return new SingleObjectResource(DJ_CONST.API.chatmessageisreadUpdateMessages).post(null, {count, id});
            },

            success: ChatMessageIsReadActions.getCreateSuccess,
            error: CurrentUserActions.pageFault
        };
    }
};

class ChatMessageIsReadStore {
    constructor() {

        this.exportAsync(ChatMessageIsReadSource);
        this.bindActions(ChatMessageIsReadActions);
    }
}

export default createStore(ChatMessageIsReadStore, 'ChatMessageIsReadStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/ChatMessageIsReadStore.js
 **/